import React from 'react';
import { TableCell } from '@material-ui/core';

import { useStyles } from './styles';
import { limitText } from 'utils/limitText';
import { ColumnDefinitionType, ITableRowsCellProps } from './interfaces';

const renderCell = <T, K extends keyof T>(row: T, column: ColumnDefinitionType<T, K>) => {
  const { key, customRender, limitTextSize } = column;

  if (typeof row[key] === 'string' && limitTextSize) {
    return limitText(row[key] as string, limitTextSize ?? 150);
  }

  if (customRender) {
    return customRender(row);
  }

  return row[key] ? row[key] : '-';
};

export const TableRowsCell = <T, K extends keyof T>({ column, row, strike }: ITableRowsCellProps<T, K>) => {
  const classes = useStyles({ columnWidth: column.columnWidth, cellAlign: column.cellAlign });
  const cellValue = renderCell(row, column);
  const cellContent = React.isValidElement(cellValue) ? cellValue : String(cellValue);
  const isStrikethrough = strike && row[column.key];
  const cellStyle = isStrikethrough ? { textDecoration: 'line-through' } : {};

  return (
    <TableCell className={classes.tableRowCell} component="th" scope="row" style={cellStyle}>
      {cellContent}
    </TableCell>
  );
};
